<div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-5 py-7 sm:px-8 sm:pt-12">
  @if (brief.step() === 'published') {
    <p class="m-0 w-fit rounded-full bg-emerald-50 px-3 py-1.5 text-sm font-bold text-emerald-800">Brief published</p>
    <div class="flex flex-col gap-3">
      <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight sm:text-5xl">Your brief is live</h1>
      <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">SHOUT is matching creators to your brief now. We'll notify you as applications come in.</p>
    </div>
  } @else {
    <p class="m-0 w-fit rounded-full bg-primary/10 px-3 py-1.5 text-sm font-bold text-primary">Saved as draft</p>
    <div class="flex flex-col gap-3">
      <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight sm:text-5xl">Your brief is saved</h1>
      <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">Find it under Briefs whenever you're ready. Nothing goes to creators until you publish.</p>
    </div>
  }

  <div class="flex items-center gap-3 rounded-xl border border-border bg-card p-4">
    <span class="flex size-11 shrink-0 items-center justify-center rounded-lg bg-brand-studio text-lg font-black text-white" aria-hidden="true">{{ brief.brandName().charAt(0) }}</span>
    <div class="min-w-0 flex-1">
      <p class="m-0 truncate text-lg font-bold">{{ brief.brief()?.title }}</p>
      <p class="m-0 text-base font-semibold text-muted-foreground">{{ brief.summaryContent() }}</p>
    </div>
    <p class="m-0 shrink-0 rounded-full px-2.5 py-1 text-sm font-bold" [class]="brief.step() === 'published' ? 'bg-emerald-50 text-emerald-800' : 'bg-primary/10 text-primary'">
      {{ brief.step() === 'published' ? 'Live' : 'Draft' }}
    </p>
  </div>

  @if (brief.error()) {
    <p class="m-0 text-base font-semibold text-red-600" role="alert">{{ brief.error() }}</p>
  }

</div>
<div class="flex shrink-0 flex-col gap-2 border-t border-border bg-background px-5 py-3 sm:px-8">
  <button type="button" class="btn-shout btn-shout-md btn-shout-primary w-full" (click)="brief.goToDashboard()">Go to my dashboard</button>
  @if (brief.step() === 'draft') {
    <button type="button" class="btn-shout btn-shout-sm btn-shout-tertiary w-full" [disabled]="brief.saving()" (click)="brief.publishNow()">Publish it now instead</button>
  }
</div>
